import { useTranslation } from 'react-i18next'

export const Instructions = () => {
  const { t } = useTranslation()

  return (
    <div className="space-y-4 p-6 text-sm">
      <div>
        <h2 className="font-bold">
          {t('memberships.membershipImports.instructions.heading_instructions')}
        </h2>
        <p>{t('memberships.membershipImports.instructions.play_value.warning')}</p>
      </div>

      <div>
        <h2 className="font-bold">{t('words.email')}</h2>
        <p>{t('memberships.membershipImports.instructions.email')}</p>
      </div>

      <div>
        <h2 className="font-bold">{t('words.expirationDate')}</h2>
        <p>{t('memberships.membershipImports.instructions.expiration_date_pass')}</p>
      </div>

      <div>
        <h2 className="font-bold">{t('playValue')}</h2>
        <p>{t('memberships.membershipImports.instructions.play_value.description')}</p>
        <p className="pt-1 font-bold">
          {t('memberships.membershipImports.instructions.label_instructions')}
        </p>
      </div>
    </div>
  )
}
